const defaultState = {
  uid: null,
  data: null,
  isLogin: false,
  isConnected: false,
}


export default function user(state = defaultState, action) {
  switch (action.type) {
    case 'AUTH_CHANGED': return {
      ...state,
      uid: action.uid,
      isAnonymous: action.isAnonymous,
      isConnected: action.uid ? state.isConnected : false,
    }

    case 'LOGIN': return {
      ...state,
      isLogin: true,
      isConnected: false,
    }

    case 'LOGIN_ERROR': return {
      ...state,
      isLogin: false,
    }

    case 'LOGIN_SUCCESS': return {
      ...state,
      isLogin: false,
      data: action.data,
      isConnected: true,
    }

    case 'LOGOUT': return {
      uid: null,
      data: null,
      isConnected: false,
    }

    default: return state
  }
}
